import React from 'react';
import VoiceAnalyticsDashboard from '../../components/analytics/VoiceAnalyticsDashboard';
import { useAuth } from '../../contexts/AuthContext';

const VoiceAnalyticsPage = () => {
  const { clientUser } = useAuth();
  const clientId = clientUser?.id;

  return (
    <div className="p-8">
      {clientId ? (
        <VoiceAnalyticsDashboard clientId={clientId} />
      ) : (
        <div className="flex items-center justify-center h-64 text-gray-400">
          <p>Please log in to view analytics</p>
        </div>
      )}
    </div>
  );
};

export default VoiceAnalyticsPage;
